import { PropsWithChildren, ReactNode, useMemo } from 'react';
import styles from './SingleAssetSubPage.module.scss';
import { useTranslation } from 'react-i18next';
import TextInfo from '@casops/components/asset-data/text-info/TextInfo';
import TimeInfo from '@casops/components/asset-data/time-info/TimeInfo';
import { EmptyCell } from '@casops/components/tables/formatters/genericFormatters';

export interface HeaderItem {
  titleTransId: string;
  value?: string;
  isTime?: boolean;
  onClick?: () => void;
}

interface SingleAssetSubPageProps {
  headerItems?: HeaderItem[];
  headerActions?: ReactNode;
  description?: string;
}

export const SingleAssetSubPage = ({
  headerItems,
  headerActions,
  description,
  children,
}: PropsWithChildren<SingleAssetSubPageProps>) => {
  const { t } = useTranslation();

  const headerItemNodes = useMemo(() => {
    if (headerItems && headerItems.length > 0) {
      const nodes = headerItems.map((item, index) => {
        const itemValue = item.value || EmptyCell;
        return item.isTime && itemValue !== EmptyCell ? (
          <TimeInfo
            key={index}
            label={t(item.titleTransId)}
            onClick={item.onClick}
            timestamp={itemValue}
          />
        ) : (
          <TextInfo
            key={index}
            label={t(item.titleTransId)}
            onClick={item.onClick}
            value={itemValue}
          />
        );
      });

      return <div className={styles.header__items}>{nodes}</div>;
    }

    return null;
  }, [headerItems, t]);

  return (
    <article className={styles.subpage}>
      {(headerItemNodes || headerActions) && (
        <header className={styles.header}>
          {headerItemNodes}
          {headerActions}
        </header>
      )}
      {description && <div className={styles.description}>{description}</div>}

      <div className={styles.content}>{children}</div>
    </article>
  );
};

export default SingleAssetSubPage;
